/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { patchState, signalStoreFeature, withMethods, withState } from "@ngrx/signals";

export const initialState: LoadingState = { loading: false };

export interface LoadingState {
  loading: boolean;
}

export function withLoading() {
  return signalStoreFeature(
    withState<LoadingState>(initialState),
    withMethods(store => ({
      setLoading(loading: boolean): void {
        patchState(store, { loading });
      },
    })),
  );
}
